module.exports = __webpack_public_path__ + "img/00046.48da8fcf.webp";